import { render, staticRenderFns } from "./GridTable.vue?vue&type=template&id=15c64c1d&scoped=true"
import script from "./GridTable.vue?vue&type=script&lang=js"
export * from "./GridTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c64c1d",
  null
  
)

export default component.exports